import { useCallback, useEffect, useState } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import { FaRegHandPointer } from 'react-icons/fa'

const PlaceHolder = ({ tenant }: { tenant?: object }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Placeholder>
      <Hint>
        <FaRegHandPointer />
        <div>Bitte geben Sie oben Ihr Geburtsjahr ein.</div>
      </Hint>
    </Placeholder>
  )
}

const Placeholder = styled.div`
  min-height: 50vh;
  font-family: var(--font-serif);
  p {
    margin-block-start: 3rem;
    margin-block-end: 3rem;
  }
`

const Hint = styled.div`
  margin-top: 35vh;
  font-family: var(--font-sans-serif);
  text-align: center;
  p {
    margin-block-start: 3rem;
    margin-block-end: 3rem;
  }
  svg {
    height: 70px;
    width: 70px;
    animation: float 4s ease-in-out infinite;
    padding-bottom: 3rem;
  }
  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(2.4rem);
    }
    100% {
      transform: translatey(0px);
    }
  }
`

export default PlaceHolder
